import React from 'react';
import 'styles/components/menu/business/InformatizationOfNDTab.scss';
import businessPerformance from 'assets/data/businessPerformance.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const InformatizationOfNDTab = () => {

    return (
        <section className='InformatizationOfNDTab'>
            <div className='InformatizationOfNDTab-wrapper'>
                <div className='title'>
                    국방정보화사업에 특화된 <br className='lineBreak pc' />
                    <span className='fw_bold'>다양한 기반기술</span>과
                    <br className='lineBreak' />
                    <span className='fw_bold'>전문 기술인력을 보유</span>하고 있습니다
                </div>
                <div className="contentBox">
                    <p>
                        국방정보화체계는
                        <span className='fw_bold'> 첨단 정보통신기술(ICT) 기반 스마트한 군사력 운용 보장</span>이라는 비전 아래
                        미래 지향적 네트워크중심작전환경(NCOE)이 조성되고 있습니다.
                    </p>
                    <p>
                        어질인소프트는 축적된 기술과 노하우를 바탕으로 첨단 ICT 기반의
                        <span className='fw_bold'> 국방정보화체계 구축 및 고도화를 위한 솔루션을 제공</span>합니다.
                        육군C4I, 해군C4I, MIMS 등의 사업을 성공적으로 수행하며 검증된 국방체계 개발방법론과 현장관리기법으로
                        <span className='fw_bold'> 안정된 고객지원 및 프로세스를 구축하여 지속적인 개발과 유지보수를 수행</span>하고 있습니다.
                    </p>
                </div>
                <div className='circles'>
                    <div className='circle-01 circle-wrapper'>
                        <div className='circle'>
                            <span className='circle-title'>
                                국방
                                <br className='lineBreak' />
                                정보화
                            </span>
                        </div>
                    </div>
                    <div className='circle-02 circle-wrapper'>
                        <div className='circle'>
                            <span className='circle-title'>
                                임무
                                <br className='lineBreak' />
                                응용/공통기능
                            </span>
                        </div>
                        <div className='text fc_grey_5 fw_normal'>
                            정보, 작전, 화력, 지속지원 등 <br className='lineBreak' />
                            주요 임무 응용 기능과 시스템관리, <br className='lineBreak' />
                            체계통합, 포탈 등 체계 공통 기능 개발
                        </div>
                    </div>
                    <div className='circle-03 circle-wrapper'>
                        <div className='circle'>
                            <span className='circle-title'>
                                상황도
                                <br className='lineBreak' />
                                /전문처리
                            </span>
                        </div>
                        <div className='text fc_grey_5 fw_normal'>
                            임무기능과 연계하여 상황도 도시 기능 개발, <br className='lineBreak' />
                            국방전자결재시스템/ TMS시스템 기능 개발
                        </div>
                    </div>
                    <div className='circle-04 circle-wrapper'>
                        <div className='circle'>
                            <span className='circle-title'>
                                체계
                                <br className='lineBreak' />
                                동기화/연동
                            </span>
                        </div>
                        <div className='text fc_grey_5 fw_normal'>
                            군단/제대간 DB2DB 등 동기화 기술 및  <br className='lineBreak' />
                            KMTF, KVMF, CDF 등 타체계 연동 기술 보유
                        </div>
                    </div>
                </div>
                <div className="performance">
                    <div className="performance-title">
                        주요사업 실적
                    </div>
                    <div className="performance-content-wrapper">
                        {
                            businessPerformance.map((el, idx) =>
                                <div key={idx} className='performance-content'>
                                    <div className='content-title fw_normal'><FontAwesomeIcon icon={faCircle} className='middle-point' /> {el.year}</div>
                                    <div className='content-text fw_normal'><span className='fw_bold'>{el.content[0]}</span><span className='fw_normal'>- {el.content[1]}</span></div>
                                </div>)
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(InformatizationOfNDTab);
